export const isProductDiscontinued = (product) => product.isDiscontinued;

export const isProductUnavailableForUS = () => false;

// re-enable US/CN check when requested: https://dev.azure.com/asos/Growth%20and%20Media/_workitems/edit/1060543
// export const isProductUnavailableForUS = (product, storeCode) =>
//   (storeCode === "US" && product.countryOfManufacture === "CN") ||
//   (storeCode === "US" && product.countryOfManufacture === "HK");

// export const isProductUnavailable = (product, store) => {
//   return (
//     isProductDiscontinued(product) || isProductUnavailableForUS(product, store)
//   );
// };

export const isProductUnavailable = (product) => {
  return isProductDiscontinued(product);
};
